module.exports = __webpack_public_path__ + "static/img/factory.5ecdd20b.svg";